import React, { useState, useEffect, useContext } from 'react'
import { motion } from 'framer-motion'
import { CreditService } from '../../services/creditService'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'
import { ThemeContext } from '../../App'

const { FiCreditCard, FiPlus, FiRefreshCw } = FiIcons

const CreditBalance = ({ user, onPurchaseClick, refreshCredits, isMobile = false }) => {
  const [credits, setCredits] = useState(0)
  const [loading, setLoading] = useState(true)
  const [refreshing, setRefreshing] = useState(false)
  const { theme } = useContext(ThemeContext)
  
  const loadCredits = async () => {
    try {
      console.log("Loading credits for user:", user.id);
      const userCredits = await CreditService.getUserCredits(user.id)
      console.log("Credits loaded:", userCredits);
      setCredits(userCredits)
    } catch (error) {
      console.error('Error loading credits:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleRefresh = async () => {
    setRefreshing(true)
    await loadCredits()
    setRefreshing(false)
    // Also call the parent refresh function if provided
    if (refreshCredits) {
      refreshCredits()
    }
  }

  useEffect(() => {
    if (user) {
      loadCredits()
    }
  }, [user])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-8 w-24">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#D59A4C]"></div>
      </div>
    )
  }

  // Mobile version
  if (isMobile) {
    return (
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="bg-[#D59A4C30] p-1.5 rounded-md mr-2">
            <SafeIcon icon={FiCreditCard} className="w-4 h-4 text-[#D59A4C]" />
          </div>
          <div className="flex items-center">
            <span className="text-sm text-gray-600 dark:text-gray-300 mr-1">Credits:</span>
            <span className="text-sm font-bold text-gray-900 dark:text-white">{credits.toFixed(1)}</span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <button 
            onClick={handleRefresh} 
            disabled={refreshing} 
            className="p-1 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors" 
            title="Refresh credits"
          >
            <SafeIcon icon={FiRefreshCw} className={`w-3 h-3 ${refreshing ? 'animate-spin' : ''}`} />
          </button>
          <button 
            onClick={onPurchaseClick} 
            className="flex items-center px-2 py-1 bg-[#D59A4C] text-white border-2 border-[#2D3748] rounded-[40px] text-xs hover:bg-[#B58C54] transition-colors" 
            title="Buy more credits"
          >
            <SafeIcon icon={FiPlus} className="w-3 h-3 mr-1" />
            Buy
          </button>
        </div>
      </div>
    )
  }

  // Desktop version
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      className="flex items-center bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 shadow-sm px-3 py-2"
    >
      <div className="flex items-center">
        <div className="bg-[#D59A4C30] p-1.5 rounded-md mr-2">
          <SafeIcon icon={FiCreditCard} className="w-3 h-3 text-[#D59A4C]" />
        </div>
        <div className="flex items-center">
          <span className="text-xs text-gray-600 dark:text-gray-300 mr-1">Credits:</span>
          <span className="text-sm font-bold text-gray-900 dark:text-white">{credits.toFixed(1)}</span>
        </div>
      </div>
      <div className="flex items-center ml-3 space-x-1">
        <button 
          onClick={handleRefresh} 
          disabled={refreshing} 
          className="p-1 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors" 
          title="Refresh credits"
        >
          <SafeIcon icon={FiRefreshCw} className={`w-3 h-3 ${refreshing ? 'animate-spin' : ''}`} />
        </button>
        <button 
          onClick={onPurchaseClick} 
          className="flex items-center px-2 py-1 bg-[#D59A4C] text-white border-2 border-[#2D3748] rounded-[40px] text-xs hover:bg-[#B58C54] transition-colors" 
          title="Buy more credits"
        >
          <SafeIcon icon={FiPlus} className="w-3 h-3 mr-1" />
          Buy
        </button>
      </div>
    </motion.div>
  )
}

export default CreditBalance